import React, { useRef, useState, useEffect } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Tooltip } from '../Tooltip/Tooltip.esm.js';

/* eslint-disable @typescript-eslint/no-non-null-assertion */
/**
 * Renders the child text, truncating it if it is longer than its container. If truncated, it will add a tooltip with the full text.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { TruncateText } from "@panwds/react-ui";
 * ```
 */
function TruncateText({ addClassName, children, dataMetrics, dataTestId, innerElementProps, ...passThrough }) {
    const inner = useRef(null);
    const outer = useRef(null);
    const [tooltip, setTooltip] = useState(false);
    useEffect(() => {
        /* istanbul ignore if */
        if (!inner.current || !outer.current) {
            return;
        }
        /* istanbul ignore if */
        if (inner.current.offsetWidth > outer.current.offsetWidth) {
            setTooltip(true);
        }
        else {
            setTooltip(false);
        }
    });
    const content = (React.createElement("span", { "data-metrics": dataMetrics, "data-testid": dataTestId ||
            `truncate-${typeof children === "string" ? testIdGen(children) : "truncate"}`, ref: outer, ...passThrough, className: classNames("tw-font-lato tw-truncate", addClassName) },
        React.createElement("span", { ref: inner, ...innerElementProps }, children)));
    /* istanbul ignore if */
    if (tooltip) {
        return (React.createElement(Tooltip, { addClassName: "tw-z-50", label: children }, content));
    }
    return content;
}

export { TruncateText };
//# sourceMappingURL=TruncateText.esm.js.map
